import React, { createContext, useContext, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { styled } from "@mui/material/styles";

const ToastContext = createContext();

export const useToast = () => {
    const context = useContext(ToastContext);

    if (!context) {
        throw new Error('useToast must be used within a ToastProvider');
    }

    return context;
};

const StyledAlert = styled(MuiAlert)`
    font-size: 0.95rem;
    border-radius: 8px;
`;

export const ToastProvider = ({ children }) => {
    const [toast, setToast] = useState({
        open: false,
        message: '',
        severity: 'info',
        duration: 3000,
    });

    const showToast = (message, severity = 'info', duration = 3000) => {
        setToast({ open: true, message, severity, duration });
    };

    const handleClose = (_, reason) => {
        if (reason === 'clickaway') return;
        setToast((prev) => ({ ...prev, open: false }));
    };

    return (
        <ToastContext.Provider value={{ showToast }}>
            {children}
            <Snackbar
                open={toast.open}
                autoHideDuration={toast.duration}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <StyledAlert
                onClose={handleClose}
                severity={toast.severity}
                elevation={6}
                variant="filled"
                >
                {toast.message}
                </StyledAlert>
            </Snackbar>
        </ToastContext.Provider>
    );
};